// IE 2026 09 15 / ODOO-… (замечание Игоря): общие «часы» муравьиной логистики на страницу — один бегунок времени для всех
// виджетов страницы (канвас потоков, карта со связями, граф). Реестр по ключу «стол::страница»: месяц, ход (play / pause), скорость,
// фаза месяца; участники регистрируют свои месяцы, шкала часов = объединение месяцев; ведущий (первый живой участник) двигает
// фазу и месяц в своём кадре, остальные в каждом кадре читают месяц часов и выпускают своих муравьёв за него.
// Участник без дат (сеть правил, месяц «all») не входит в шкалу и выпускает муравьёв на каждом круге часов.
const clocks = {}

export function antClock(key) {
    // IE 2026 09 16 (заказ Игоря): total — режим «итоги за весь период»: участники показывают значения, сложенные по всем месяцам
    // шкалы (меры с агрегатом WAvg — средневзвешенно по своему Basis, как в графике); муравьи при этом идут по месяцам как обычно
    return clocks[key] || (clocks[key] = { key, timeline: [], month: null, playing: true, speed: 1, phase: 0, lap: 0, master: null, members: new Map(), monthMs: 1400, total: false })
}

// IE 2026 09 15 (уточнение Игоря): шкала одна и та же у всех виджетов страницы — НЕПРЕРЫВНЫЙ ряд месяцев от самого раннего до самого
// позднего по всем участникам; месяц без данных у виджета = отсутствие движения в этом периоде (муравьи не выпускаются)
// IE 2026 09 15 (заказ Игоря): чипс периода стола задаёт шкалу времени — при заданном интервале (c.range) шкала = его месяцы, данные вне
// интервала не показываются; без чипса — как раньше, от самого раннего до самого позднего месяца участников
function rebuild(c) {
    let min = null, max = null
    for (const m of c.members.values()) for (const x of (m.months || [])) { if (!x || x === 'all') continue; if (!min || x < min) min = x; if (!max || x > max) max = x }
    if (c.range && c.range.from && c.range.to) { min = c.range.from; max = c.range.to }
    const out = []
    if (min && max) {
        let [y, mo] = min.slice(0, 7).split('-').map(Number); const [y1, m1] = max.slice(0, 7).split('-').map(Number)
        while (y < y1 || (y === y1 && mo <= m1)) { out.push(`${y}-${String(mo).padStart(2, '0')}-01`); mo++; if (mo > 12) { mo = 1; y++ } }
    }
    c.timeline = out
    if (!c.timeline.length) { c.month = null; return }
    if (!c.month || !c.timeline.includes(c.month)) c.month = c.timeline[0]
}
export const antMonthKey = (d) => { const s = String(d || '').slice(0, 7); return /^\d{4}-\d{2}$/.test(s) ? s + '-01' : '' }

// IE 2026 09 15 (заказ Игоря): интервал чипса периода стола (строка WHERE «date between») → шкала часов; зовётся участниками в кадре —
// при смене чипса шкала перестраивается, месяц вне интервала — на первый. true — шкала изменилась
export function antClockSyncPeriod(c, store, WIDGET) {
    const WHERE = store?.WORKSPACES?.[WIDGET?.workspace]?.record?.doc?.params?.WHERE
    const row = Array.isArray(WHERE) ? WHERE.find(w => w && w.leftValue && w.leftValue.value === 'date' && w.condition === 'between') : null
    const ok = !!(row && row.use !== false && row.rightValue && row.rightValue.value && row.rightValue.valueTo)
    const from = ok ? antMonthKey(row.rightValue.value) : '', to = ok ? antMonthKey(row.rightValue.valueTo) : ''
    const sig = from + '|' + to
    if (c.rangeSig === sig) return false
    c.rangeSig = sig
    c.range = (from && to && from <= to) ? { from, to } : null
    const before = c.month
    rebuild(c)
    if (c.month !== before) { c.phase = 0; c.lap++ }
    return true
}

export function antClockJoin(c, id, months) {
    c.members.set(id, { months: (months || []).slice() })
    rebuild(c)
    if (!c.master || !c.members.has(c.master)) c.master = id
}

export function antClockLeave(c, id) {
    c.members.delete(id)
    rebuild(c)
    if (c.master === id) c.master = c.members.keys().next().value || null
}

// ведущий двигает фазу; true — месяц сменился (или начался новый круг у часов без шкалы)
export function antClockTick(c, id, dt) {
    if (c.master !== id || !c.playing) return false
    c.phase += dt * c.speed / c.monthMs
    if (c.phase < 1) return false
    c.phase = 0
    if (!c.timeline.length) { c.lap++; return true }
    const i = c.timeline.indexOf(c.month)
    const j = i + 1 >= c.timeline.length ? 0 : i + 1
    if (j === 0) c.lap++
    c.month = c.timeline[j]
    return true
}

export function antClockSeek(c, month) { if (month) c.month = month; c.phase = 0; c.lap++ }   // lap++ — участники сбрасывают выпущенных
export function antClockSeekIndex(c, i) { if (c.timeline.length) antClockSeek(c, c.timeline[Math.max(0, Math.min(c.timeline.length - 1, i))]) }
export function antClockRestart(c) { c.phase = 0; c.lap++; c.month = c.timeline[0] || null; c.playing = true; c.total = false }   // IE 2026 09 16: заново — по месяцам
// IE 2026 09 16 (уточнение Игоря): Σ = данные за весь период → часы на паузе; play в режиме Σ — обратно к месяцам и ход
// IE 2026 09 16 (заказ Игоря): стартовый режим часов — по умолчанию Σ (итоги за весь период, пауза); задаёт ПЕРВЫЙ участник страницы
// по своей настройке (map_ants_total / graph_ants_total / ant_total_start; false — ход по месяцам), позже режим меняет только кнопка Σ
export function antClockStartMode(c, total) { if (c._started) return; c._started = true; c.total = !!total; c.playing = !total }
export function antClockToggle(c) { if (c.total) { c.total = false; c.playing = true; return } c.playing = !c.playing }
export function antClockSpeed(c) { c.speed = c.speed >= 4 ? 1 : c.speed * 2 }
export function antClockTotal(c) { c.total = !c.total; c.playing = !c.total }   // IE 2026 09 16 (заказ Игоря): итоги за весь период (пауза) ⇄ значения месяца (ход)
export function antClockSig(c) { return `${c.month}|${c.playing}|${c.speed}|${c.timeline.length}|${c.lap}|${c.total ? 'T' : ''}` }

if (typeof window !== 'undefined') window.antClocks = clocks   // диагностика и пробы
